module.exports = __webpack_public_path__ + "img/riasatjomhoori.b95a31c.svg";